export const isSSR = () => typeof window === 'undefined';
//# sourceMappingURL=is-ssr.js.map